module.exports = __webpack_public_path__ + "img/spear.wooden.ad422d0f.png";